export var InviteErrorCode;
(function (InviteErrorCode) {
    InviteErrorCode[InviteErrorCode["UserAlreadyExists"] = 0] = "UserAlreadyExists";
    InviteErrorCode[InviteErrorCode["PendingInviteExists"] = 1] = "PendingInviteExists";
    InviteErrorCode[InviteErrorCode["ValidationError"] = 2] = "ValidationError";
    InviteErrorCode[InviteErrorCode["PermissionDenied"] = 3] = "PermissionDenied";
    InviteErrorCode[InviteErrorCode["InternalError"] = 4] = "InternalError";
})(InviteErrorCode || (InviteErrorCode = {}));
/**
 * Maps invite error codes to translation keys for user-friendly error messages
 */
export function getInviteErrorTranslationKey(errorCode) {
    switch (errorCode) {
        case InviteErrorCode.UserAlreadyExists:
            return "user-invite.error-user-already-exists";
        case InviteErrorCode.PendingInviteExists:
            return "user-invite.error-pending-invite-exists";
        case InviteErrorCode.ValidationError:
            return "user-invite.error-validation-error";
        case InviteErrorCode.PermissionDenied:
            return "user-invite.error-permission-denied";
        case InviteErrorCode.InternalError:
        default:
            return "user-invite.error-internal-error";
    }
}
/**
 * Maps invite statuses to translation keys for user-friendly status error messages
 */
export function getInviteStatusTranslationKey(status) {
    switch (status) {
        case "Expired":
            return "invite-signup.status-errors.expired";
        case "Accepted":
            return "invite-signup.status-errors.accepted";
        case "Cancelled":
            return "invite-signup.status-errors.cancelled";
        case "Pending":
        default:
            return "invite-signup.status-errors.invalid";
    }
}
/**
 * Get the relevant date for each invite status (returns the raw date string)
 */
export function getInviteStatusDate(invite) {
    switch (invite.status) {
        case "Pending":
            return invite.lastSentAt ?? invite.createdAt;
        case "Accepted":
            return invite.acceptedAt;
        case "Cancelled":
            return invite.cancelledAt;
        case "Failed":
            return invite.createdAt;
        case "Expired":
            return invite.expiresAt;
        default:
            return invite.createdAt;
    }
}
